"use client";
import React, { useState, useEffect } from "react";
import {
  Home,
  Star,
  Brain,
  Users,
  MessageCircle,
  User,
  Menu,
  X,
  LogOut,
  ClipboardList,
  Globe,
  MessageSquare,
  IndianRupee,
  LayoutList,
  LayoutGrid,
  LayoutPanelTop,
} from "lucide-react";
import { NavLink, useLocation } from "react-router-dom";
import LoginModal from "./LoginModal";
import {
  removeData,
  retrieveData,
  storeData,
} from "../../LocalConnection/LocalConnection";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import logo from "../../Assests/logo.png";
const navLinks = [
  { name: "Home", icon: <Home className="w-4 h-4" />, to: "/" },
  { name: "Kundli", icon: <Star className="w-4 h-4" />, to: "/kundli" },
  {
    name: "AstroForum",
    icon: <MessageCircle className="w-4 h-4" />,
    to: "/forum",
  },
  {
    name: "Daily Predictions",
    icon: <Brain className="w-4 h-4" />,
    to: "/daily",
  },
  {
    name: "Expert Astrologers",
    icon: <Users className="w-4 h-4" />,
    to: "/experts",
  },
];
export default function Header({ isLogin }) {
  const customer_id = retrieveData("customer_id");
  const customer_name = retrieveData("customer_name");
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(isLogin || false);
  const [showChartModal, setShowChartModal] = useState(false);
  const [selectedChartType, setSelectedChartType] = useState("north");
  const [showLanguageModal, setShowLanguageModal] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(1);

  //chart type
  useEffect(() => {
    const savedChartType = retrieveData("selectedChartType");
    setSelectedChartType(savedChartType);
    if (savedChartType != "") {
      setSelectedChartType(savedChartType);
    } else {
      setSelectedChartType("north");
    }
  }, []);

  //  language
  useEffect(() => {
    const savedLanguage = retrieveData("customer_langauge");
    if (savedLanguage != "") {
      setSelectedLanguage(savedLanguage);
    } else {
      setSelectedLanguage(1);
    }
  }, []);

  useEffect(() => {
    setShowLogin(isLogin);
  }, [isLogin]);

  const handleChartModalOpen = () => {
    setShowChartModal(true);
  };
  const handleChartModalClose = () => {
    setShowChartModal(false);
    setSidebarOpen(false);
  };

  const handleSaveChartType = () => {
    storeData("selectedChartType", selectedChartType);
    setShowChartModal(false);
    setSidebarOpen(false);
    window.location.reload();
  };

  const handleChartSelect = (type) => setSelectedChartType(type);
  const navigate = useNavigate();
  useEffect(() => {
    setShowLogin(isLogin);
  }, [isLogin]);

  const handleLogout = () => {
    removeData();
  };
  //---------------Languade Modal

  const handleLanguageModalOpen = () => {
    setShowLanguageModal(true);
  };

  const handleLanguageModalClose = () => {
    setShowLanguageModal(false);
    setSidebarOpen(false);
  };

  const handleSaveLanguage = () => {
    storeData("customer_langauge", selectedLanguage);
    setShowLanguageModal(false);
    setSidebarOpen(false);
    window.location.reload();
  };

  const handleLanguageSelect = (lang) => setSelectedLanguage(lang);
  //---------------Philosophy Modal-------------

  const handleLoginClick = () => {
    setShowLogin(true);
  };

  const handleCloseModal = () => {
    setShowLogin(false);
  };

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const SidebarItem = ({ icon, label, onClick }) => (
    <div
      className="flex items-center gap-2 cursor-pointer hover:bg-purple-600/20 p-2 rounded"
      onClick={onClick}
    >
      {icon}
      {label}
    </div>
  );

  return (
    <>
      {/* HEADER */}
      <div className="sticky top-0 z-[999] bg-[var(--light-black)] border-b-[1px] border-purple-500/20 text-white">
        <header className="max-w-[1300px] mx-auto px-4 py-3 flex items-center justify-between">
          {/* Logo */}

          <NavLink
            to="/"
            className="flex items-center font-bold  text-xl gap-2"
          >
            <img src={logo} className="width_height_logo" />
            <span className="bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent text-[20px]">
              AstroLogical: Forum &amp; Kundli
            </span>
          </NavLink>

          {/* Desktop Nav */}
          <nav className="hidden lg:flex gap-4 items-center">
            {navLinks.map((link) => {
              const isActive = location.pathname === link.to;
              return (
                <NavLink
                  key={link.name}
                  to={link.to}
                  onClick={() => setIsOpen(false)}
                  className={`flex items-center gap-2 font-medium text-sm px-3 py-2 rounded-lg hover:bg-[var(--primary-hover)] transition-all
                    ${
                      isActive
                        ? "bg-[var(--primary-color)] text-white"
                        : "text-white hover:text-purple-300"
                    }`}
                >
                  {link.icon}
                  {link.name}
                </NavLink>
              );
            })}
          </nav>

          {/* Profile / Login / Mobile Toggle */}
          <div className="flex items-center gap-4">
            {!customer_id || customer_id === 0 ? (
              <div
                className="hidden lg:flex cursor-pointer items-center gap-1 border border-purple-200 bg-purple-50 text-[var(--primary-color)] px-4 py-1.5 rounded-lg font-medium text-sm hover:bg-[--primary-hover-dark] hover:text-white transition"
                onClick={handleLoginClick}
              >
                <User className="w-4 h-4" /> Login
              </div>
            ) : (
              <div
                onClick={toggleSidebar}
                className="hidden lg:flex items-center gap-1 cursor-pointer border border-purple-500 text-white px-3 py-1.5 rounded-full hover:bg-purple-600 transition-all"
              >
                <User className="w-5 h-5" />
                <p className="text-[15px] mb-0">{customer_name}</p>
              </div>
            )}
            {!customer_id || customer_id === 0 ? (
              <div
                className="lg:hidden cursor-pointer flex items-center gap-1 border border-purple-200 bg-purple-50 text-[var(--primary-color)] px-4 py-1.5 rounded-lg font-medium text-sm hover:bg-[--primary-hover-dark] hover:text-white transition"
                onClick={handleLoginClick}
              >
                <User className="w-4 h-4" /> Login
              </div>
            ) : (
              <button className="lg:hidden text-white" onClick={toggleSidebar}>
                {isOpen ? <X /> : <Menu />}
              </button>
            )}
          </div>
        </header>
      </div>
      {/* 🔲 Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-[998] backdrop-blur-sm bg-black/30 transition-opacity"
          onClick={toggleSidebar}
        ></div>
      )}

      {/* 👉 Profile Sidebar */}
      <div
        className={`fixed top-0 right-0 z-[999] h-full w-[300px] bg-[#131629] shadow-lg transform transition-transform ${
          sidebarOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="flex flex-col h-full">
          <div className="flex items-center justify-between p-4 border-b border-purple-500/20">
            <h3 className="text-lg font-bold text-white">
              👤{" "}
              {customer_name && customer_name.length > 10
                ? customer_name.slice(0, 15) + "..."
                : customer_name || "Guest"}
            </h3>
            <button onClick={toggleSidebar}>
              <X className="text-white" />
            </button>
          </div>

          <div className="flex flex-col gap-2 p-4 text-white text-sm  overflow-y-auto h-[100vh]">
            <SidebarItem
              icon={<User className="w-4 h-4" />}
              label="My Profile"
              onClick={() => {
                navigate("/profile");
                toggleSidebar();
              }}
            />
            <SidebarItem
              icon={<ClipboardList className="w-4 h-4" />}
              label="My Questions"
              onClick={() => {
                navigate("/my-questions");
                toggleSidebar();
              }}
            />
            <SidebarItem
              icon={<Globe className="w-4 h-4" />}
              label="Language"
              onClick={handleLanguageModalOpen}
            />
            <SidebarItem
              icon={<LayoutList className="w-4 h-4" />}
              label="Chart Type"
              onClick={handleChartModalOpen}
            />
            <SidebarItem
              icon={<MessageSquare className="w-4 h-4" />}
              label="My Replies"
              onClick={() => {
                navigate("/my-replies");
                toggleSidebar();
              }}
            />
            <SidebarItem
              icon={<IndianRupee className="w-4 h-4" />}
              label="My Payments"
              onClick={() => {
                navigate("/my-payments");
                toggleSidebar();
              }}
            />
          </div>

          <div className="mt-auto p-4">
            <button
              onClick={handleLogout}
              className="flex items-center gap-2 w-full text-sm bg-[var(--primary-color)] text-white px-3 py-2 rounded hover:bg-[var(--primary-hover-dark)] transition"
            >
              <LogOut className="w-4 h-4" />
              Logout
            </button>
          </div>
        </div>
      </div>

      <LoginModal show={showLogin} handleClose={handleCloseModal} />

      {/**-----------------Chart Type ModaL------------- */}
      <Modal
        show={showChartModal}
        onHide={handleChartModalClose}
        centered
        backdrop="static"
        backdropClassName="backdrop-blur-sm"
        dialogClassName="custom-modal-style"
      >
        <div className="bg-[#1a1d3b] rounded-xl shadow-lg border border-purple-500 text-white p-4 relative">
          <div className="flex justify-between items-center border-b border-purple-500 pb-2 mb-4">
            <h3 className="text-lg font-normal text-white">
              Select Chart Type
            </h3>
            <X
              onClick={handleChartModalClose}
              size={28}
              className="cursor-pointer absolute right-[0.2rem] md:right-[-2rem] top-[-2.2rem] md:top-[-2rem] rounded-full bg-white text-black p-[5px] shadow-md hover:scale-110 transition-transform duration-200"
            />
          </div>

          <div className="flex flex-col gap-4">
            {/* North Chart */}
            <div
              className={`flex items-center gap-3 p-4 rounded-lg cursor-pointer transition-all duration-200 ${
                selectedChartType === "north"
                  ? "bg-purple-600/20 border border-purple-400"
                  : "bg-[#22264d] border border-white/10 hover:border-purple-500"
              }`}
              onClick={() => handleChartSelect("north")}
            >
              <input
                type="radio"
                name="chartType"
                checked={selectedChartType === "north"}
                onChange={() => handleChartSelect("north")}
                className="accent-purple-500"
              />
              <LayoutGrid className="w-5 h-5 text-purple-300" />
              <span className="font-medium">North Chart</span>
            </div>

            {/* South Chart */}
            <div
              className={`flex items-center gap-3 p-4 rounded-lg cursor-pointer transition-all duration-200 ${
                selectedChartType === "south"
                  ? "bg-purple-600/20 border border-purple-400"
                  : "bg-[#22264d] border border-white/10 hover:border-purple-500"
              }`}
              onClick={() => handleChartSelect("south")}
            >
              <input
                type="radio"
                name="chartType"
                checked={selectedChartType === "south"}
                onChange={() => handleChartSelect("south")}
                className="accent-purple-500"
              />
              <LayoutPanelTop className="w-5 h-5 text-purple-300" />
              <span className="font-medium">South Chart</span>
            </div>
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <button
              onClick={() => {
                setSidebarOpen(false);
                handleChartModalClose();
              }}
              className="px-4 py-2 text-sm font-medium text-white bg-gray-600 hover:bg-gray-700 rounded"
            >
              Cancel
            </button>
            <button
              onClick={() => {
                handleSaveChartType();
              }}
              className="px-4 py-2 text-sm font-medium bg-[var(--primary-color)] hover:bg-[var(--primary-hover-dark)] text-white rounded"
            >
              Save
            </button>
          </div>
        </div>
      </Modal>
      {/*-------------------Languge Modal------------------*/}
      <Modal
        show={showLanguageModal}
        onHide={handleLanguageModalClose}
        centered
        backdrop="static"
        backdropClassName="backdrop-blur-sm"
        dialogClassName="custom-modal-style"
      >
        <div className="bg-[#1a1d3b] rounded-xl shadow-lg border border-purple-500 text-white p-4 relative">
          <div className="flex justify-between items-center border-b border-purple-500 pb-2 mb-4">
            <h3 className="text-lg font-normal text-white">Select Language</h3>
            <X
              onClick={handleLanguageModalClose}
              size={28}
              className="cursor-pointer absolute right-[0.2rem] md:right-[-2rem] top-[-2.2rem] md:top-[-2rem] rounded-full bg-white text-black p-[5px] shadow-md hover:scale-110 transition-transform duration-200"
            />
          </div>

          <div className="flex flex-col gap-4">
            {/* English Option */}
            <div
              className={`flex items-center gap-3 p-4 rounded-lg cursor-pointer transition-all duration-200 ${
                parseInt(selectedLanguage) === 1
                  ? "bg-purple-600/20 border border-purple-400"
                  : "bg-[#22264d] border border-white/10 hover:border-purple-500"
              }`}
              onClick={() => handleLanguageSelect(1)}
            >
              <input
                type="radio"
                name="language"
                checked={parseInt(selectedLanguage) === 1}
                onChange={() => handleLanguageSelect(1)}
                className="accent-purple-500"
              />
              <span className="font-medium">English</span>
            </div>

            {/* Hindi Option */}
            <div
              className={`flex items-center gap-3 p-4 rounded-lg cursor-pointer transition-all duration-200 ${
                parseInt(selectedLanguage) === 2
                  ? "bg-purple-600/20 border border-purple-400"
                  : "bg-[#22264d] border border-white/10 hover:border-purple-500"
              }`}
              onClick={() => handleLanguageSelect(2)}
            >
              <input
                type="radio"
                name="language"
                checked={parseInt(selectedLanguage) === 2}
                onChange={() => handleLanguageSelect(2)}
                className="accent-purple-500"
              />
              <span className="font-medium">Hindi</span>
            </div>
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <button
              onClick={() => {
                setSidebarOpen(false);
                handleLanguageModalClose();
              }}
              className="px-4 py-2 text-sm font-medium text-white bg-gray-600 hover:bg-gray-700 rounded"
            >
              Cancel
            </button>
            <button
              onClick={handleSaveLanguage}
              className="px-4 py-2 text-sm font-medium bg-[var(--primary-color)] hover:bg-[var(--primary-hover-dark)] text-white rounded"
            >
              Save
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}
